import * as bekit from 'bekit';
const { Url, Ua } = bekit.helper;

export default {
    setCouponList (arr) {
        let map = {}
        for (let i = 0; i < arr.length; i++) {
            let hashstr = ''
            for (const key in arr[i]) {
                if(key != 'id' && key != 'outerId') {
                    hashstr += arr[i][key]
                }
            }
            if (map[hashstr] != undefined) {
                map[hashstr].num++
            } else {
                arr[i].num = 1
                map[hashstr] = arr[i]
            }
        }
        return Object.values(map);
    },
    homeworkPageData(v) {
        const data = {
            homework: {
                name: 'homework',
                title: '作业内容',
                template: 'v-homework-rule',
                modalTitle: '作业提交后不可修改，确认提交？',
                submitUrl: '/homework/submit',
                message: '作业加载中…',
                id: 'lessonId',
                getUrl: "/homework",
            },
            activity: {
                name: 'activity',
                title: '活动报名',
                template: 'v-homework-activity-rule',
                modalTitle: '活动问卷提交后不可修改，确认提交？',
                submitUrl: '/homework/submit-activity-survey',
                message: '活动加载中…',
                id: 'activityId',
                getUrl: "/homework/activity-survey",
            }
        }
        return data[v]
    },
    format(date, pattern) {
        const week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            weekcn = ["日", "一", "二", "三", "四", "五", "六"];
        let fo = {
            yyyy: date.getFullYear(),
            M: date.getMonth() + 1,
            d: date.getDate(),
            Day: date.getDay(),
            h: date.getHours(),
            m: date.getMinutes(),
            s: date.getSeconds(),
        };
        const items = {
            yy: fo.yyyy % 100,
            MM: Math.floor(fo.M / 10).toString() + fo.M % 10,
            dd: Math.floor(fo.d / 10).toString() + fo.d % 10,
            DD: week[fo.Day],
            DC: weekcn[fo.Day],
            D: week[fo.Day].slice(0, 3),
            hh: Math.floor(fo.h / 10).toString() + fo.h % 10,
            mm: Math.floor(fo.m / 10).toString() + fo.m % 10,
            ss: Math.floor(fo.s / 10).toString() + fo.s % 10,
        };
        Object.keys(items)
            .forEach(key => {
                fo[key] = items[key];
            });
        return pattern.replace(/(yyyy|yy|MM|M|dd|d|DD|DC|D|hh|h|mm|m|ss|s)/g, function(mat, item) {
            return fo[item];
        });
    },
    countdown(fn, ddl, interval = 1000) {
        const timer = {
            destroy,
            isDestroyed: false,
        };
        // 先执行一遍，再执行定时器
        set();
        const intervalId = setInterval(set, interval);

        function set() {
            let milliseconds = ddl - Date.now();
            if (milliseconds < 0) {
                destroy();
            } else {
                fn(milliseconds);
            }
        }

        function destroy() {
            clearInterval(intervalId);
            timer.isDestroyed = true;
        }
        return timer;
    },
    formatTimeDiff(milliseconds, pattern = ['d天', 'h小时', 'm分'], options) {
        if (typeof pattern === 'string') pattern = [pattern];
        options = Object.assign({
            omit: true,
            join: true,
            joinChar: ' ',
            returnMap: false,
        }, options);
        const scale = [
            ['d', 1000 * 60 * 60 * 24],
            ['h', 1000 * 60 * 60],
            ['m', 1000 * 60],
            ['s', 1000],
            ['S', 1],
        ];
        const keys = scale.map(i => i[0]);
        const r = new RegExp("(" + keys.join("|") + ")");
        let fo = {};
        pattern.forEach(i => {
            fo[i.match(r)[0]] = {
                value: 0,
                pattern: i,
                format: '',
            };
        });
        scale.forEach(i => {
            let key = i[0];
            if (fo[key] === undefined) return;
            let val = Math.floor(milliseconds / i[1]);
            fo[key].value = val;
            milliseconds -= val * i[1];
        });
        let flag = false;
        let res = pattern.reduce((sum, cur) => {
            let key = cur.match(r)[0];
            let val = cur.replace(r, fo[key].value);
            let unit = cur.replace(r, '');
            fo[key].format = val;
            fo[key].unit = unit;
            if (options.omit && !flag && fo[key].value === 0) return sum;
            flag = true;
            return sum.concat([val]);
        }, []);
        if (options.returnMap) return fo;
        if (options.join) res = res.join(options.joinChar);
        return res;
    },
    // 节流函数
    throttle(fn, interval = 200) {
        let firstTime = true,
            timer;
        return function() {
            if (timer) return;
            let _this = this;
            if (!firstTime) {
                fn.apply(_this, arguments);
                return firstTime = false;
            }
            timer = setTimeout(() => {
                clearTimeout(timer);
                timer = null;
                fn.apply(_this, arguments);
            }, interval);
        }
    },
    getRandomNum(length, radix = 10) {
        let result = '';
        for (let i = 0; i < length; i++) {
            result += Math.floor(Math.random() * radix).toString(radix);
        }
        return result;
    },
    urlAddHash(url, key = 't') {
        let timestamp = +new Date(),
            urlObj = new Url(url);
        return urlObj.replaceParams({
            [key]: timestamp
        }).toString();
    },
    // 兼容安卓微信webview的reload()失效问题
    reload() {
        if (Ua.isAndroid()) return location.href = this.urlAddHash(location.href);
        return location.reload();
    },
    // 解决vue-router 默认的?from=a&from=b的解析问题
    getRouteQuery(param = '') {
        let params = new Url(location.href).params || {}
        if (param) {
            return params.param || '';
        } else {
            return params;
        }
    },
    // 处理数据
    getTextNode(arr) {
        let childNodes = [];
        if (arr) {
            arr.forEach(it => {
                if (it.nodeName == "IMG") {
                    childNodes.push(it.setURL || it.src);
                } else if (it.nodeName == "OL" || it.nodeName == "UL") {
                    childNodes.push(this.getULOLdTextNodes(it.innerHTML, it.nodeName));
                } else {
                    childNodes.push(it.outerText);
                }
            });
            let str = childNodes.join("\n").replace(/<\/?.+?>/g, "");
            str = str.replace(/ /g, "");
            return str;
        } else {
            return ''
        }
    },
    // 处理有序和无序
    getULOLdTextNodes(innerHTML, flag) {
        let html = innerHTML.replace("/<" + flag + ">/g", "").split("<li>"),
            htmlUL = [];
        html = html.filter(function (s) {
            return s && s.trim();
        });
        html.forEach((itno, index) => {
            let dom = itno.replaceAll(/<\/li>/g, "");
            if (itno) {
                if (flag === "OL") {
                    htmlUL.push(index + 1 + "." + dom);
                } else {
                    htmlUL.push("·" + dom);
                }
            }
        });
        return htmlUL.join("\n");
    },
};